export default __webpack_public_path__ + "static/media/golf-starterpack-blue.52157bcc.png";